import playEnvironment from "./play-environment"
import {
  DEFAULT_DRAW_IMAGE,
  emptyConnect,
  emptyDragDrop,
  emptyDrawing,
  emptyHistoryPage,
  emptyKeyboard,
  emptyMap,
  emptyOpenText,
  emptyProfilePageState,
  emptyTimerState,
  PlayHubState,
} from "./play-model"
import { Theme } from "models/tables"
import { hasText } from "utils/helpers"

function emptyInitialState(): PlayHubState {
  const themeBackground = document.documentElement.getAttribute(
    "data-theme-background"
  )
  const themeId = parseInt(
    document.documentElement.getAttribute("data-theme-id") || ""
  )
  let theme: Theme | null = null
  if (hasText(themeBackground) && !isNaN(themeId) && themeId > 0) {
    theme = {
      backgroundUrl: themeBackground!,
      id: themeId,
    }
  }

  let state: PlayHubState = {
    isServerRequestInProgress: false,
    connectionId: playEnvironment.connectionId,
    oldConnectionId: playEnvironment.connectionId,
    startClassroomGameAttemptedCount: 0,
    studentPageLoaded: false,
    studentPageLoading: false,
    teacherPageLoading: false,
    teacherPageLoaded: false,
    lessonId: null,
    classId: playEnvironment.classId,
    className: playEnvironment.classId,
    reportId: null,
    lessonName: null,
    lessonImage: null,
    isTeacherUrl: false,
    isPreview: false,
    isReview: false,
    canReviewNextScreen: false,
    canReviewPrevScreen: false,
    screenId: null,
    teacherConnectionId: null,
    isStudentRemoved: false,
    fullName: playEnvironment.fullName,
    mode: playEnvironment.gameMode,

    isBusinessVersion: false,

    countAnsweredStudents: 0,
    countStartedStudents: 0,
    answerExplanationPosition: undefined,

    gameCode: playEnvironment.gameCode || "",
    enableGraphicalLogin: playEnvironment.enableGraphicalLogin,

    playError: null,
    isReconnecting: false,

    joinError: null,

    loggedUser: null,
    loggedUserInfoReceived: false,

    // serverTime: null as Date | null,

    //studentAvatars: [] as StudentAvatar[],
    students: [],
    studentsInLobby: [],

    sessionStarted: false,
    serverErrorData: undefined,
    serverError: null,

    loadingReason: null,
    internalPage: null,
    screen: null,
    gameCompleted: false,
    screenIndex: -1,
    countScreens: 0,
    points: 0,
    lastScreenPoints: 0,
    lastScreenIsCorrect: false,
    leaderboard: [],
    feedbackDurationInSeconds: 0,
    accuracy: 0,
    memeUrl: null,
    disableMemes: false,
    screenFinishedResponse: null,
    correctAnswerText: null,
    correctAnswerIds: [],

    imagesToPreload: [DEFAULT_DRAW_IMAGE],
    imagesPreloaded: false,

    timer: emptyTimerState(),
    nextTimer: null,

    navigationIsLoading: false,
    nextScreenButtonIsVisible: false,
    nextScreenButtonIsActive: false,
    prevScreenButtonIsVisible: false,
    prevScreenButtonIsActive: false,

    showCorrectAnswers: false,
    showAnswerExplanation: false,

    //shuffleAnswers: false,
    //shuffleConnectPairs: true,
    //shuffleDragDropZones: false,
    //shuffleDragDropAnswerPiles: true,
    finished: false,

    certificates: [],

    // state computed form ClientScreen
    dragDrop: emptyDragDrop(),
    quizAnswers: [],
    map: emptyMap(),
    keyboard: emptyKeyboard(),
    connect: emptyConnect(),
    history: emptyHistoryPage(),
    drawing: emptyDrawing(),
    pollAnswers: [],
    openText: emptyOpenText(),
    loginUrl: null,
    theme: theme,

    profilePage: emptyProfilePageState(),
  }

  return state
}

export const INITIAL_STATE = emptyInitialState()
